import { Card, CardTitle, Separator } from '@repo/shadcn';

import { CustomerFormDefaultValues } from '@/modules/customers';
import { useCreateCustomer } from '@/modules/customers/create-customer/create-customer.hook';
import { CustomerForm } from '@/modules/customers/customer-form/customer.form';

export const CreateCustomerModal = () => {
    const { onSubmit, isLoading } = useCreateCustomer();
    return (
        <Card className={'space-y-4 border-none shadow-none'}>
            <CardTitle>Create New Customer</CardTitle>
            <Separator />
            <CustomerForm
                onSubmit={onSubmit}
                isLoading={isLoading}
                initialValues={CustomerFormDefaultValues}
            />
        </Card>
    );
};

CreateCustomerModal.displayName = 'CreateCustomerModal';
